import React, { useState } from "react";
import { Drawer, Button } from "antd";
import Localize from "./localize";
// import Icons from "components/icons";


const DrawerStandart = ({
    modalButton,
    extraClass = "",
    disabled = false,
    width = "287",
    title,
    visible: externalVisible,
    onClose,
    onReset,
    onSubmit,
    footer = false,
    ...props
}) => {

    const [ internalVisible, setInternalVisible ] = useState(false);

    const showModal = externalVisible !== undefined ? externalVisible : internalVisible;

    const handleClose = onClose || (() => setInternalVisible(false));

    return (
        <>
            {modalButton && React.cloneElement(modalButton, {
                disabled,
                onClick: () => setInternalVisible(true)
            })}

            <Drawer
                className={`drawer-standard ${extraClass}`}
                visible={showModal}
                width={width}
                placement="right"
                title={title}
                onClose={handleClose}
                footer={footer && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {onReset && (
                            <Button onClick={onReset}>
                                <Localize>FORMS.Button_Text_Cancel</Localize>
                            </Button>
                        )}
                        {onSubmit && (
                            <Button type="primary" onClick={onSubmit}>
                                <Localize>FORMS.Button_Text_ApplyFilters</Localize>
                            </Button>
                        )}
                    </div>
                )}
            >
                {Array.isArray(props.children) ?
                    props.children.map(
                        (child, index) => React.cloneElement(child, { key: index, action: handleClose })
                    ) :
                    props.children && React.cloneElement(props.children, { action: handleClose })
                }
            </Drawer>
        </>
    );
}

export default DrawerStandart;